import { Link } from "react-router-dom";

/** Minimal legal footer used across public/auth pages. */
export default function LegalFooter({ dark = true }) {
  const base = dark
    ? "border-t border-white/10 bg-transparent"
    : "border-t border-slate-200 bg-white";
  const text = dark ? "text-slate-500" : "text-slate-600";
  const link = dark ? "hover:text-white" : "hover:text-slate-900";
  return (
    <footer className={`${base} py-6 mt-10`} data-testid="legal-footer">
      <div className="max-w-5xl mx-auto px-5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className={`text-xs uppercase tracking-widest ${text}`}>© {new Date().getFullYear()} Footymatch. UK 18+.</p>
        <nav className={`flex gap-5 text-xs uppercase tracking-widest ${text}`}>
          <Link to="/terms" className={link} data-testid="footer-terms">Terms</Link>
          <Link to="/privacy" className={link} data-testid="footer-privacy">Privacy</Link>
          <Link to="/guidelines" className={link} data-testid="footer-guidelines">Community</Link>
        </nav>
      </div>
    </footer>
  );
}
